module.exports = __webpack_public_path__ + "img/SL-M-120-140.b8f2e9cf.svg";